import * as z from "zod";

export const setupContextualDomain = {
  name: "setupContextualDomain" as const,
  input: z.object({
    domain: z.string(),
    /**
     * Register the merchant and turn tracking on without a ctx CNAME. Events
     * route through Contextual's shared endpoint until the merchant adds the
     * record, which they can do later from the dashboard.
     */
    skipCname: z.boolean().optional(),
  }),
  output: z.object({ hostnameId: z.string().nullable() }),
};
